<template>
  <div>
    <!-- فلتر البلازما الآيوني -->
    <FrameImages
      style="background: #eaebef"
      class="ion-anim"
      :nFrames="20"
      startImgUrl="https://fresh-products.s3.eu-west-1.amazonaws.com/ion/ionAnim-"
      imgUrl="https://fresh-products.s3.eu-west-1.amazonaws.com/ion/ionAnim-1.jpg"
      :frameSpeed="60"
      containerName=".ion-anim"
      :spacer="true"
      :imgHeight="500"
      :StartAnimBefore="450"
    >
      <template v-slot:text>
        <h1 class="px-4">فلتر البلازما الآيوني</h1>
        <p class="mt-3 mb-14 px-4">
          فلتر يحافط على بيئة نقية داخل الثلاجـة و يقضــى <br />
          علــى البكتريــا والروائح الكريهة
        </p>
      </template>
    </FrameImages>
    <!-- فلتر البلازما الآيوني -->
    <!-- خاصية البلوتوث -->
    <FrameImages
      class="blu-anim black"
      :nFrames="22"
      startImgUrl="https://fresh-products.s3.eu-west-1.amazonaws.com/bluAnim/bluetooth-anim-"
      imgUrl="https://fresh-products.s3.eu-west-1.amazonaws.com/bluAnim/bluetooth-anim-1.jpg"
      containerName=".blu-anim"
      :frameSpeed="60"
      :imgHeight="0"
      :spacer="false"
      :StartAnimBefore="850"
    >
      <template v-slot:text>
        <h1 class="px-4 mt-13 white--text">خاصية البلوتوث</h1>
        <p class="px-4 mt-3 gray-text">
          تمكنـــك من <span class="white--text">إجــراء المكالمــات</span> دون
          الحاجــة إلى حمـل الهاتـف و
          <span class="white--text">الاستماع الى الموسيقى </span>
        </p>
      </template>
    </FrameImages>
    <!-- خاصية البلوتوث -->
    <!-- إضائة LED -->
    <section class="scroll-shadow-container black">
      <div class="shadow-img-container-mb">
        <img
          style="object-position: left"
          class="shadow-img"
          src="@/assets/LED door.jpg"
          alt=""
        />
        <div class="shadow-box"></div>
        <h1 class="px-4 mt-5 white--text">إضائة LED</h1>
        <p class="mt-3 gray-text px-4 gray--text darken-3 pb-15">
          وحدات الإضاءة <span class="white--text">الأكثر</span> سطوعاً
          <span class="white--text"> و أقل أستهلاكاً </span> <br />
          للطاقة وعمر أفتراضى <span class="white--text">أطول</span>
        </p>
      </div>
    </section>
    <!-- إضائة LED -->

    <!-- شاشة ديجيتال -->
    <div class="bg-text-fade large-img">
      <img
        style="position: sticky; top: 150px"
        src="@/assets/Panel.svg"
        alt=""
      />
      <div class="anim-text-1">
        <h1 class="px-4 white--text">شاشة ديجيتال</h1>
        <p class="mt-3 px-4 gray-text">
          شاشــة ديجيتــال تمكنــك مــن
          <span class="white--text"
            >التحكم بشكل <br />
            أفضل
          </span>
          بخـواص الثلاجات بسهولة
        </p>
      </div>
    </div>
    <!-- شاشة ديجيتال -->

    <!-- fresh zone -->
    <section class="main-section text-anim mt-14 pb-5">
      <center>
        <img
          class="mb-1"
          src="@/assets/fresh zone.jpg"
          style="width: 100vw; object-fit: cover; height: 340px"
          alt=""
        />
      </center>
      <h1 class="px-4 mt-15">منطقة الطعام الطازج</h1>
      <p class="mt-3 px-4 gray-text">
        احتفظ بماكولاتك ظازجة مع منطقة حفظ الطعام الطازجة لدينا، ستحافظ على
        لحومك وأسماكك طازجة لمدة تصل إلى ثلاثة أيام.
      </p>
    </section>
    <!-- fresh zone -->

    <!-- درج خضروات كبير -->
    <section class="main-section text-anim mt-9 pb-5">
      <center>
        <img
          class="mb-1"
          src="@/assets/big-box.jpg"
          style="width: 100vw; object-fit: cover; height: 340px"
          alt=""
        />
      </center>
      <h1 class="px-4">درج خضروات كبير</h1>
      <p class="mt-3 mb-12 px-4 gray-text">
        درج خضــروات كبير الحجم مما يسمح بتخزيــن خضروات أكثر ودائمـا طازجة
      </p>
    </section>
    <!-- درج خضروات كبير -->

    <!-- إنذار غلق الباب -->
    <section class="main-section text-anim pb-5">
      <center>
        <img
          class="mb-4"
          src="@/assets/alarm-fridge.jpg"
          style="width: 100vw; object-fit: cover; height: 340px"
          alt=""
        />
      </center>
      <h1 class="px-4 mt-10">إنذار غلق الباب</h1>
      <p class="mt-3 px-4 gray-text">
        عنـد تــرك البـاب مفتـوح تطلق الثلاجـة إنـذار لحفـظ <br />
        الطعـام فى الثلاجة والفريزر
      </p>
    </section>
    <!-- إنذار غلق الباب -->

    <!-- رفوف الثلاجة -->
    <section class="main-section text-anim mt-4 pb-5">
      <center>
        <img
          class="mb-1"
          src="@/assets/test2222.jpg"
          style="
            width: 100vw;
            transform: scale();
            height: 243px;
            object-fit: cover;
          "
          alt=""
        />
      </center>
      <h1 class="px-4">رفوف الثلاجة</h1>
      <p class="mt-3 px-4 gray-text">
        رفوف الثلاجة تتمتع بقوة ومتانة لا مثيل لهما. قم بتخزين مشترياتك بثقة ولا
        تقلق بعد الآن بشأن الأرفف فهى تتحمل
      </p>
    </section>
    <!-- رفوف الثلاجة -->

    <!-- معلومات الضمان -->
    <section class="black px-5 mt-8 py-12 rounded-lg mx-3 d-flex align-center">
      <div>
        <h1 class="px-4 white--text">معلومات الضمان</h1>
        <p style="font-size: 16px" class="white--text mb-0 mt-0">
          <span style="opacity: 0.7">تلاجات فريش ضمانك مكمل لحد</span> <br />
          <span style="opacity: 1"> 10 سنوات</span>
        </p>
      </div>
      <v-spacer></v-spacer>
      <img src="@/assets/warranty.svg" style="width: 100px" alt="" />
    </section>
    <!-- معلومات الضمان -->

    <h1 class="px-4 mt-15 mb-7">تفاصيل المنتج</h1>
    <section class="specs">
      <div>
        <img src="@/assets/specs/Model Code.svg" alt="" />
        <p>كود المنتج</p>
        <p>500011967</p>
      </div>

      <div>
        <img src="@/assets/specs/Model Name.svg" alt="" />
        <p>اسم الموديل</p>
        <p>MR470YIGQMod INV</p>
      </div>

      <div>
        <img src="@/assets/specs/Capacity.svg" alt="" />
        <p>السعة</p>
        <p>397 L</p>
      </div>

      <div>
        <img src="@/assets/specs/color-swatch-svgrepo-com.svg" alt="" />
        <p>اللون</p>
        <p>اسود</p>
      </div>
      <div>
        <img src="@/assets/specs/Material of Shelves.svg" alt="" />
        <p>مادة الرفوف</p>
        <p>زجاج</p>
      </div>
      <div>
        <img src="@/assets/specs/atom.svg" alt="" />
        <p>
          فلتر بلازما <br />
          ايونايزر
        </p>
      </div>
      <div>
        <img src="@/assets/specs/bluetooth.svg" alt="" />
        <p>بولوتوث تكنولوجى</p>
      </div>

      <div>
        <img src="@/assets/specs/Door Alarm.svg" alt="" />
        <p>انذار الباب</p>
      </div>

      <div>
        <img src="@/assets/specs/frsh zone.svg" alt="" />
        <p>حافظة الطعام طازج</p>
      </div>

      <div>
        <img src="@/assets/specs/Ice Maker.svg" alt="" />
        <p>صانع الثلج</p>
      </div>

      <div>
        <img src="@/assets/specs/touch.svg" alt="" />
        <p>
          شاشة تحكم <br />
          باللمس
        </p>
      </div>

      <div>
        <img src="@/assets/specs/Voltage Control.svg" alt="" />
        <p>
          التحكم فى التيار <br />
          الكهربائي
        </p>
      </div>

      <div>
        <img src="@/assets/specs/warranty.svg" alt="" />
        <p>ضمان خارجي</p>
      </div>

      <div>
        <img src="@/assets/specs/width.svg" alt="" />
        <p>عرض</p>
        <p>655 mm</p>
      </div>
      <div>
        <img src="@/assets/specs/Height.svg" alt="" />
        <p>ارتفاع</p>
        <p>1755 mm</p>
      </div>

      <div>
        <img src="@/assets/specs/Depth.svg" alt="" />
        <p>العمق</p>
        <p>635 mm</p>
      </div>
    </section>
    <video
      controls
      style="width: 100vw; margin-bottom: -8px; height: 40vh; object-fit: cover"
      src="https://fresh-products.s3.eu-west-1.amazonaws.com/Refrigerator2.mp4"
      poster="@/assets/banner.png"
    ></video>
  </div>
</template>

<script>
import FrameImages from "@/components/FrameImages";
export default {
  components: { FrameImages },
  mounted() {
    let sections = document.querySelectorAll(".text-anim");

    window.addEventListener("scroll", () => {
      sections.forEach((sec) => {
        if (
          window.scrollY >= sec.offsetTop - 500 &&
          !sec.classList.contains("animate")
        ) {
          sec.classList.add("animate");
        } else if (
          window.scrollY <= sec.offsetTop - 1200 &&
          sec.classList.contains("animate")
        ) {
          sec.classList.remove("animate");
        }
      });
    });

    const gsap = window.gsap;
    gsap.to(["#vid-scroll-container img.tv", "#vid-scroll-container video"], {
      css: { zoom: 0.6, opacity: 1 },
      ease: "power2.inOut",
      yoyo: true, // if true > A-B-B-A, if false > A-B-A-B
      yoyoEase: true,
      scrollTrigger: {
        trigger: "#vid-scroll-container",
        start: "top+=50 top",
        end: "bottom+=300 bottom",
        scrub: true,
      },
    });
    gsap.from(["#vid-scroll-container .box-contier img.tv-box"], {
      scale: 1.5,
      ease: "power2.out",
      yoyo: true,
      yoyoEase: true,
      scrollTrigger: {
        trigger: "#vid-scroll-container",
        start: "bottom-=200 bottom",
        end: "bottom+=550 bottom",
        scrub: true,
      },
    });
    gsap.fromTo(
      ".shadow-img-container-mb .shadow-box",
      { opacity: 1 },
      {
        opacity: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".scroll-shadow-container",
          start: "start start",
          end: "bottom bottom",
          scrub: true,
        },
      }
    );

    gsap.to(".bg-text-fade.large-img div.anim-text-1", {
      opacity: 1,
      ease: "power2.inOut",
      yoyo: true, // if true > A-B-B-A, if false > A-B-A-B
      yoyoEase: true,
      scrollTrigger: {
        trigger: ".bg-text-fade.large-img",
        start: "bottom bottom+=200",
        end: "bottom bottom-=100",
        scrub: true,
      },
    });
  },
};
</script>

<style scoped>
.text-anim h1 {
  opacity: 0;
  transform: translateY(35px);
  transition: 0.7s ease;
}
.text-anim.animate h1 {
  opacity: 1;
  transform: translateY(0px);
}
.text-anim p {
  opacity: 0;
  transform: translateY(20px);
  transition: 0.7s ease-out;
  transition-delay: 0.5s;
}
.text-anim.animate p {
  opacity: 1;
  transform: translateY(0px);
}
.bg-text-fade {
  height: calc(100vh + 50px);
  background: black;
  position: relative;
}
.bg-text-fade.small-img {
  height: 550px;
  position: relative;
  background-color: white;
}
.bg-text-fade div {
  padding: 50px 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  box-shadow: 0px -8px 20px rgb(0 0 0 / 90%);
}
.bg-text-fade.small-img div.anim-text-2 {
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  backdrop-filter: blur(5px);
  box-shadow: none;
}

#vid-scroll-container {
  position: relative;
  height: calc(100vh + 400px);
}
#vid-scroll-container .img-container,
#vid-scroll-container .vid-container {
  position: absolute;
  top: 0;
  left: 0%;
  height: calc(100% - 200px);
  width: 100%;
}

#vid-scroll-container img.tv {
  position: sticky;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 2;
  -o-object-fit: cover;
  object-fit: cover;
  opacity: 0;
}
.gray-section {
  background: #f1f0ef;
  margin: 0 15px;
  border-radius: 10px;
  overflow: hidden;
}
.gray-section img {
  margin-bottom: -6px;
}
.left-img {
  display: block;
  margin-left: auto;
}
#vid-scroll-container .vid-container video {
  height: 100vh;
  -o-object-position: center;
  object-position: center;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  position: sticky;
  top: 0px;
}
h1 {
  font-size: 25px;
  font-weight: bolder;
  text-shadow: 1px 1px 2px rgb(0 0 0 / 5%);
  text-align: center;
}
h1.gradiant {
  background: -webkit-linear-gradient(
    -45deg,
    #4167a3 0%,
    #b8c5d8 50%,
    #4167a3 100%
  );
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -ms-background-clip: text;
  -webkit-text-fill-color: transparent;
}
p {
  font-size: 18px;
  margin-top: 15px;
  font-weight: bold;
  text-align: center;
  line-height: 30px;
  max-width: 450px;
}
.shadow-img-container-mb img {
  width: 100%;
  height: 66vh;
  object-fit: cover;
}
.shadow-img-container-mb {
  position: sticky;
  top: 0;
}
.shadow-img-container-mb .shadow-box {
  position: absolute;
  width: 100%;
  height: 67vh;
  top: 0;
  left: 0;
  background-image: linear-gradient(
    132deg,
    rgba(0, 0, 0, 0.9) 30%,
    rgba(0, 0, 0, 0) 40%,
    rgba(0, 0, 0, 0.9) 70%
  );
}
.scroll-shadow-container {
  height: 160vh;
  position: relative;
}
.gray-bg {
  background-color: #f5f5f7;
}
.gray-text {
  color: #6c757d;
}

.specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 150px;
  margin: 0 20px;
}
.specs div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.specs div img {
  margin-bottom: 15px;
  max-width: 30px;
  max-height: 30px;
}
.specs div p {
  margin: 0;
  font-size: 17px;
}
</style>
